"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _partial = _interopRequireDefault(require("transmute/partial"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BundlePage = require("../BundlePage");

var _utils = require("../utils");

var _ContactsItem = _interopRequireDefault(require("./ContactsItem"));

var _EmptyShoppingCart = _interopRequireDefault(require("./EmptyShoppingCart"));

var _ShoppingCartItem = _interopRequireDefault(require("./ShoppingCartItem"));

var _ShoppingCartPrices = _interopRequireDefault(require("./ShoppingCartPrices"));

var _BundlePricingBreakdownModal = _interopRequireDefault(require("../BundlePricingBreakdownModal"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../../utils/responsiveBreakpoints"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _UIScrollContainer = _interopRequireDefault(require("UIComponents/scroll/UIScrollContainer"));

var _GrowthSuiteAlert = _interopRequireDefault(require("./GrowthSuiteAlert"));

var _CovidSelectors = require("../../../selectors/CovidSelectors");

var _BundlesCtaContainer = _interopRequireDefault(require("../BundlesCtaContainer"));

var _PricingSelectors = require("../../../selectors/PricingSelectors");

var _MerchandiseSelectors = require("../../../selectors/MerchandiseSelectors");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-top: 1px ", " solid;\n  padding: 15px 0;\n  margin: 10px -20px 0;\n  background-color: ", ";\n  text-align: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 600;\n  margin-bottom: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 1px;\n  width: 100%;\n  background-color: ", ";\n  margin: 20px 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border: 1px ", " solid;\n  width: 340px;\n  padding: 20px 20px 0 20px;\n  margin-bottom: 20px;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ShoppingCartContainer = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCart__ShoppingCartContainer",
  componentId: "xkvapz-0"
})(_templateObject(), _colors.BATTLESHIP, _responsiveBreakpoints.default.cs(_templateObject2()));

var Spacer = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCart__Spacer",
  componentId: "xkvapz-1"
})(_templateObject3(), _colors.BATTLESHIP);

var BundleTitle = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCart__BundleTitle",
  componentId: "xkvapz-2"
})(_templateObject4());

var PricingBreakdownSection = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCart__PricingBreakdownSection",
  componentId: "xkvapz-3"
})(_templateObject5(), _colors.BATTLESHIP, _colors.GYPSUM);

function ShoppingCart(_ref) {
  var merchandiseMap = _ref.merchandiseMap,
      isCovidGrowthSuitePromoEligible = _ref.isCovidGrowthSuitePromoEligible;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var togglePriceBreakdown = function togglePriceBreakdown(isVisible, merchandiseIds) {
    setModalVisibility(isVisible);

    if (isVisible) {
      (0, _getUsageTracker.default)().track('clickToViewModal', {
        name: 'price-breakdown-modal',
        merchandise: merchandiseIds
      });
    }
  };

  var calculateBundlePrice = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculateBundlePriceSelector);
  var marketingPlanSelected = state.marketingPlanSelected,
      salesPlanSelected = state.salesPlanSelected,
      servicePlanSelected = state.servicePlanSelected,
      cmsPlanSelected = state.cmsPlanSelected,
      salesUnits = state.salesUnits,
      serviceUnits = state.serviceUnits,
      selectedAddOns = state.selectedAddOns,
      selectedServices = state.selectedServices,
      marketingUnits = state.marketingUnits;
  var isCartEmpty = !marketingPlanSelected && !salesPlanSelected && !servicePlanSelected && !cmsPlanSelected && !selectedAddOns && !selectedServices;

  if (isCartEmpty) {
    return _react.default.createElement(ShoppingCartContainer, null, _react.default.createElement(_EmptyShoppingCart.default, null));
  }

  var bundleSelections = {
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    cmsPlanSelected: cmsPlanSelected,
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices
  };
  var isGrowthSuiteSelected = (0, _utils.isGrowthSuiteSelection)(bundleSelections, merchandiseMap);
  var isCovidStarterSuitePromoEligible = !!(isCovidGrowthSuitePromoEligible && _utils.isGrowthSuiteSelection && merchandiseMap);
  var totalPrice = calculateBundlePrice({
    bundleSelections: bundleSelections,
    isGrowthSuite: isGrowthSuiteSelected,
    isCovidPromo: isCovidStarterSuitePromoEligible
  });
  var covidAlertPrice = calculateBundlePrice({
    // Limit selections to core products so addon/services/etc's prices don't show up in the alert
    bundleSelections: {
      marketingPlanSelected: marketingPlanSelected,
      salesPlanSelected: salesPlanSelected,
      servicePlanSelected: servicePlanSelected
    },
    isGrowthSuite: isGrowthSuiteSelected,
    isCovidPromo: isCovidStarterSuitePromoEligible
  });
  var merchandiseIds = (0, _utils.bundleMerchandiseIds)({
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    cmsPlanSelected: cmsPlanSelected,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices
  });
  var gaClassName = (0, _publicPageUrls.getGAClassName)('bundle-pricing-breakdown');

  var getIncludedAdditionalUnits = function getIncludedAdditionalUnits(merchId) {
    return merchandiseMap[merchId].includedAdditionalUnits;
  };

  return _react.default.createElement(ShoppingCartContainer, null, _react.default.createElement(_BundlesCtaContainer.default, {
    bundleSelections: bundleSelections
  }), _react.default.createElement(Spacer, null), _react.default.createElement(BundleTitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.shoppingCart.yourBundle"
  })), _react.default.createElement(_UIScrollContainer.default, {
    maxHeight: 380,
    gradientColor: _colors.GREAT_WHITE
  }, marketingPlanSelected && _react.default.createElement(_ContactsItem.default, null), salesPlanSelected && _react.default.createElement(_ShoppingCartItem.default, {
    merchandiseId: salesPlanSelected,
    additionalUnitQuantity: salesUnits,
    unit: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.shoppingCart.additionalUsers",
      "data-selenium-class": "shopping-cart-item-unit",
      options: {
        count: getIncludedAdditionalUnits(salesPlanSelected) + salesUnits
      }
    }),
    onRemove: function onRemove() {
      return setState({
        salesPlanSelected: null,
        salesUnits: 0
      });
    }
  }), servicePlanSelected && _react.default.createElement(_ShoppingCartItem.default, {
    merchandiseId: servicePlanSelected,
    additionalUnitQuantity: serviceUnits,
    unit: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.shoppingCart.additionalUsers",
      "data-selenium-class": "shopping-cart-item-unit",
      options: {
        count: getIncludedAdditionalUnits(servicePlanSelected) + serviceUnits
      }
    }),
    onRemove: function onRemove() {
      return setState({
        servicePlanSelected: null,
        serviceUnits: 0
      });
    }
  }), cmsPlanSelected && _react.default.createElement(_ShoppingCartItem.default, {
    merchandiseId: cmsPlanSelected,
    onRemove: function onRemove() {
      return setState({
        cmsPlanSelected: null
      });
    }
  }), selectedAddOns.map(function (merchandiseId) {
    var onRemove = function onRemove() {
      return setState({
        selectedAddOns: selectedAddOns.filter(function (id) {
          return id !== merchandiseId;
        })
      });
    };

    return _react.default.createElement(_ShoppingCartItem.default, {
      key: merchandiseId,
      merchandiseId: merchandiseId,
      onRemove: onRemove
    });
  }), selectedServices.map(function (merchandiseId) {
    var onRemove = function onRemove() {
      return setState({
        selectedServices: selectedServices.filter(function (id) {
          return id !== merchandiseId;
        })
      });
    };

    return _react.default.createElement(_ShoppingCartItem.default, {
      key: merchandiseId,
      merchandiseId: merchandiseId,
      onRemove: onRemove
    });
  })), _react.default.createElement(Spacer, null), _react.default.createElement(_ShoppingCartPrices.default, {
    totalPrice: totalPrice
  }), _react.default.createElement(_GrowthSuiteAlert.default, {
    isGrowthSuiteSelected: isGrowthSuiteSelected,
    covidPromoProps: {
      // Proxy marketingPlanSelected's edition for edition of entire growth suite selection
      activeEdition: _utils.isGrowthSuiteSelection && marketingPlanSelected && merchandiseMap[marketingPlanSelected].edition,
      fromPrice: covidAlertPrice.monthly.fullPrice,
      toPrice: covidAlertPrice.monthly.calculatedPrice
    }
  }), _react.default.createElement(PricingBreakdownSection, null, _react.default.createElement(_UILink.default, {
    onClick: (0, _partial.default)(togglePriceBreakdown, true, merchandiseIds),
    className: gaClassName
  }, _react.default.createElement(_FormattedMessage.default, {
    className: gaClassName,
    message: "pricingPage.calculator.priceBreakdown.link"
  }))), isModalVisible && _react.default.createElement(_BundlePricingBreakdownModal.default, {
    totalPrice: totalPrice,
    onCloseClick: (0, _partial.default)(togglePriceBreakdown, false),
    bundleSelections: bundleSelections
  }));
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    merchandiseMap: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    isCovidGrowthSuitePromoEligible: (0, _CovidSelectors.isCovidGrowthSuitePromoEligibleSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ShoppingCart);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ShoppingCart.js
// module id = 706
// module chunks = 5 6